import * as t from 'io-ts';

import {RCalendarEventParameters} from '../../store/panels/calendars/calendarsPanelState';
import {makeApiSerializableType} from './apiTypes';

/*
 * Runtime type.
 */

export const RCalendarNotificationLinkParameters = t.readonly(
  t.type({
    focusedDate: t.number,
    calendarEventParameters: RCalendarEventParameters,
  }),
);

/*
 * Type.
 */

export interface CalendarNotificationLinkParameters
  extends t.TypeOf<typeof RCalendarNotificationLinkParameters> {}

/*
 * IO methods.
 */

export function parseCalendarNotificationLinkParameters(src: any): CalendarNotificationLinkParameters {
  return {
    focusedDate: src.focusedDate,
    calendarEventParameters: src.calendarEventParameters,
  };
}

export function serializeCalendarNotificationLinkParameters(
  calendarNotificationLinkParameters: CalendarNotificationLinkParameters,
) {
  return {
    focusedDate: calendarNotificationLinkParameters.focusedDate,
    calendarEventParameters: calendarNotificationLinkParameters.calendarEventParameters,
  };
}

/*
 * API type.
 */

export const ApiCalendarNotificationLinkParameters = makeApiSerializableType(
  'calendarNotificationLinkParameters',
  RCalendarNotificationLinkParameters,
  parseCalendarNotificationLinkParameters,
  serializeCalendarNotificationLinkParameters,
);
